import * as React from 'react';
import * as styles from './styles.css';
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Counter = function Counter(_ref) {
  var total = _ref.total,
    current = _ref.current;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [current, "/", total]
  });
};
Counter.displayName = 'Counter';